export default __webpack_public_path__ + "92b1867d528635e8b1d7f2c6be4d1405.webp";